<script setup>
import { ref } from "vue";
import { links } from '@/helper/adminLinks.js';
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const rail = ref(true);
const drawerOpen = ref(false);
const route = useRoute();
const store = useStore();
const opened = ref([]);
const userRole = store.state.role;

const checkRoute = (link) => {
    return link.children.some(child => child.href === route.path);
};
</script>

<template>
    <v-navigation-drawer
        floating
        :rail="rail"
        expand-on-hover
        rail-width="80"
        class="shadow-md py-5 text-[#2B4466] custom-scroll h-screen fixed"
        @mouseenter="drawerOpen = true"
        @mouseleave="drawerOpen = false; opened = []"
    >
        <v-list nav class="z-[1]" v-model:opened="opened">
            <v-list-item class="mb-6" @click="$router.push('/admin')">
                <div class="flex items-center">
                    <img src="/images/admin/sidebar_logo.svg" alt="logo" class="w-14 h-14" />
                    <v-list-item-title class="text-[#127CC1] font-bold text-2xl leading-6 ml-4">
                        KMG HR
                    </v-list-item-title>
                </div>
            </v-list-item>

            <template
                v-for="(link, index) of links"
                :key="index"
            >
                <v-list-group
                    v-if="link.children && userRole && link.roles.some(role => userRole.includes(role))"
                    no-action
                    class="mb-2 ml-1"
                    :value="index"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            v-bind="props"
                            density="compact"
                            class="sidebar-link"
                            :class="checkRoute(link) && drawerOpen
                                ?   'bg-[#127CC1] text-white hover:bg-[#127CC1]'
                                :   'bg-transparent hover:bg-[#E8F2F9]'
                            "
                            rounded
                        >
                            <template v-slot:prepend>
                                <div
                                    class="rounded-md p-1 w-fit"
                                    :class="checkRoute(link) ? 'bg-[#127CC1]' : 'bg-[#E8F2F9]'"
                                >
                                    <v-icon size="large">
                                        <img
                                            v-if="checkRoute(link)"
                                            :src="link.active_icon"
                                            class="w-7 h-7 min-w-7 min-h-7"
                                        />
                                        <img
                                            v-else
                                            :src="link.icon"
                                            class="w-7 h-7 min-w-7 min-h-7"
                                        />
                                    </v-icon>
                                </div>
                            </template>
                            <v-list-item-title class="ml-3">
                                {{ link.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>

                    <template
                        v-for="child of link.children"
                        :key="child.href"
                    >
                        <v-list-item
                            v-if="userRole && child.roles.some(role => userRole.includes(role))"
                            active-class="bg-[#E8F2F9]"
                            class="sidebar-link hover:bg-[#E8F2F9]"
                            rounded
                            density="compact"
                            @click="$router.push(child.href); opened = [];"
                        >
                            <v-list-item-title>
                                {{ child.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-list-group>

                <v-list-item
                    v-else-if="!link.children && userRole && link.roles.some(role => userRole.includes(role))"
                    active-class="bg-[#E8F2F9]"
                    class="sidebar-link mb-2 ml-1"
                    :class="route.path == link.href && drawerOpen
                        ?   'bg-[#127CC1] text-white hover:bg-[#127CC1]'
                        :   'bg-transparent hover:bg-[#E8F2F9]'
                    "
                    rounded
                    density="compact"
                    @click="$router.push(link.href); opened = [];"
                >
                    <template v-slot:prepend>
                        <div
                            class="rounded-md p-1 w-fit"
                            :class="route.path == link.href ? 'bg-[#127CC1]' : 'bg-[#E8F2F9]'"
                        >
                            <v-icon size="large">
                                <img
                                    v-if="route.path == link.href"
                                    :src="link.active_icon"
                                    class="w-7 h-7 min-w-7 min-h-7"
                                />
                                <img
                                    v-else
                                    :src="link.icon"
                                    class="w-7 h-7 min-w-7 min-h-7"
                                />
                            </v-icon>
                        </div>
                    </template>
                    <v-list-item-title class="ml-3">
                        {{ link.title }}
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
        <img
            v-show="drawerOpen"
            src="/images/kmg_logo_bg.svg"
            class="absolute right-0 bottom-0 z-0 h-[600px] w-11/12 opacity-20"
        />
    </v-navigation-drawer>
</template>

<style>
.sidebar-link .v-list-item__overlay {
    background: transparent;
}
</style>